module.exports = __webpack_public_path__ + "static/media/angle-double-right.104b9b74.svg";